export const fontFamily = ['Jost', 'sans-serif'].join(',');
export const htmlFontSize = 16;

export default {
  fontFamily,
  htmlFontSize,
};
